export const pollNotificationsEnabled = true
export const BACKEND_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://cpgateway.bestcase.com'
    : process.env.REACT_APP_ENV === 'staging'
    ? 'https://cpgateway-stg.bestcase.com'
    : process.env.REACT_APP_ENV === 'load'
    ? 'https://cpgateway-load.bestcase.com'
    : process.env.REACT_APP_ENV === 'qa'
    ? 'https://cpqagateway.bestcase.com'
    : process.env.REACT_APP_ENV === 'dev'
    ? 'https://cpdevgateway.bestcase.com'
    : // : 'https://localhost:44384'
      'https://localhost:44384'
// : 'https://localhost:50628'
// : 'https://localhost:44397'

export const WSBACKEND_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'wss://cpgateway.bestcase.com'
    : process.env.REACT_APP_ENV === 'staging'
    ? 'wss://cpstggateway.bestcase.com'
    : process.env.REACT_APP_ENV === 'load'
    ? 'wss://cpload.bestcase.com'
    : process.env.REACT_APP_ENV === 'qa'
    ? 'wss://cpqagateway.bestcase.com'
    : process.env.REACT_APP_ENV === 'dev'
    ? 'wss://cpdevgateway.bestcase.com'
    : 'wss://cpdevgateway.bestcase.com'
// : 'https://cpqagateway.bestcase.com'
// : 'https://localhost:50628'
// : 'https://localhost:44397'

export const graphqlEndpoint = `${BACKEND_URL}/graphql/`

export const wsGraphqlEndpoint = `${WSBACKEND_URL}/graphql/`

/// Interface to store specific configuration for the app
export default interface AppConfiguration {
  documents: {
    maxFilesUpload: number
    maxTotalFilesSize: number
    maxFileSize: number
  }
}

/// Returns the configuration for the app. When ENV is not set, means it's local dev
export const getAppConfiguration = (): AppConfiguration => {
  const env = process.env.REACT_APP_ENV
  const maxFilesUpload =
    env === 'qa' || env === 'dev' || env === undefined ? 10 : 50

  return {
    documents: {
      maxFilesUpload,
      maxTotalFilesSize: 95 * 1024 * 1024, // default 95Mb
      maxFileSize: 25 * 1024 * 1024 // default 25Mb
    }
  }
}

export const APP_DYNAMICS_CDN = '//cdn.appdynamics.com/adrum/adrum-latest.js'

export const appDynamicsContent = (): string => {
  const scriptBody = (key: string) => `
  window["adrum-start-time"] = new Date().getTime();
  (function(config){
      config.appKey = "${key}";
      config.adrumExtUrlHttp = "http://cdn.appdynamics.com";
      config.adrumExtUrlHttps = "https://cdn.appdynamics.com";
      config.beaconUrlHttp = "http://pdx-col.eum-appdynamics.com";
      config.beaconUrlHttps = "https://pdx-col.eum-appdynamics.com";
      config.resTiming = {"bufSize":200,"clearResTimingOnBeaconSend":true};
      config.maxUrlLength = 512;
      config.spa = {"spa2":true};
  })(window["adrum-config"] || (window["adrum-config"] = {}));
  `

  switch (process.env.REACT_APP_ENV) {
    case 'production': {
      return scriptBody('AD-AAB-ABN-PDP')
    }
    case 'staging': {
      return scriptBody('AD-AAB-ABN-PCV')
    }
    default:
      return scriptBody('AD-AAB-ABN-PCW')
  }
}

export const pendoContent = (): string => {
  const scriptBody = (key: string) => `(function (apiKey) {
    (function (p, e, n, d, o) {
      let v, w, x, y, z
      o = p[d] = p[d] || {}
      o._q = []
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad']
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              )
            }
        })(v[w])
      y = e.createElement(n)
      y.async = !0
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'
      z = e.getElementsByTagName(n)[0]
      z.parentNode.insertBefore(y, z)
    })(window, document, 'script', 'pendo');
  })('${key}')`

  switch (process.env.REACT_APP_ENV) {
    case 'production': {
      return scriptBody('33bd23b1-8e66-4e97-7f81-be47f72b414c')
    }
    case 'staging': {
      return scriptBody('33bd23b1-8e66-4e97-7f81-be47f72b414c')
    }
    default:
      return scriptBody('33bd23b1-8e66-4e97-7f81-be47f72b414c')
  }
}

export interface LogRocketConfig {
  serverUrl: string
  projectName: string
  inputSanitizer: boolean
  isEnabled: boolean
}

export const getLogRocketConfig = (): LogRocketConfig => {
  const config: LogRocketConfig = {
    serverUrl: `https://subenv4-logrocket.stretto.com`,
    projectName: `stretto-sandbox/clientportal`,
    inputSanitizer: false,
    isEnabled: true
  }

  switch (process.env.REACT_APP_ENV) {
    case 'production': {
      config.serverUrl = `https://prod4-logrocket.stretto.com`
      config.projectName = `stretto/clientportal`
      config.inputSanitizer = false
      config.isEnabled = true
      break
    }
    case 'qa': {
      config.isEnabled = true
      break
    }
    case 'staging': {
      config.isEnabled = true
      break
    }
    default: {
      config.isEnabled = false
    }
  }

  return config
}

function createOneTrustScript() {
  let oneTrustGuid = '019a7ed6-9bdf-7f93-98a1-22cd73868143-test'
  if (
    process.env.REACT_APP_ENV == 'production' ||
    process.env.REACT_APP_ENV == 'ProdAws'
  ) {
    oneTrustGuid = '019a7ed6-9bdf-7f93-98a1-22cd73868143'
  }

  const oneTrustSrc = `https://cdn.cookielaw.org/consent/${oneTrustGuid}/OtAutoBlock.js`

  const scriptElement1 = document.createElement('script')
  scriptElement1.src = oneTrustSrc
  scriptElement1.type = 'text/javascript'

  document.head.appendChild(scriptElement1)

  const scriptElement2 = document.createElement('script')
  scriptElement2.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
  scriptElement2.type = 'text/javascript'
  scriptElement2.setAttribute('charset', 'UTF-8')
  scriptElement2.setAttribute(
    'data-domain-script',
    '019a7ed6-9bdf-7f93-98a1-22cd73868143-test'
  )

  if (
    process.env.REACT_APP_ENV == 'production' ||
    process.env.REACT_APP_ENV == 'ProdAws'
  ) {
    scriptElement2.setAttribute(
      'data-domain-script',
      '019a7ed6-9bdf-7f93-98a1-22cd73868143'
    )
  }
  document.head.appendChild(scriptElement2)
}

createOneTrustScript()
